import { createMuiTheme } from '@material-ui/core';
import { theme } from '../../Theme';
const materialTheme = (overrides = {}) => {
  const { MuiFormControl = {} } = overrides;
  const { root: MuiFormControlRoot = {} } = MuiFormControl;
  return createMuiTheme({
    ...theme,
    overrides: {
      MuiFormControl: {
        root: {
          width: '100%',
          ...MuiFormControlRoot
        }
      },
      MuiOutlinedInput: {
        root: {
          position: 'relative'
        }
      },
      MuiInputAdornment: {
        root: {
          position: 'absolute',
          right: 4
        }
      },
      MuiIconButton: {
        root: {
          padding: 8
        }
      }
    }
  });
};

export default materialTheme;
